module.exports = __webpack_public_path__ + "img/report_sample.41b40114.jpg";